/**
 * A hand-rolled horizontal bar chart for a small breakdown (by state, by ward,
 * top pages, referrers). No chart dependency: each bar is a one-rect inline SVG
 * scaled to the largest value, with the label and count as plain type either
 * side. Poster aesthetic -- hairline track, solid accent fill.
 */

export interface BarDatum {
  label: string;
  value: number;
}

export function BarChart({
  data,
  caption,
}: {
  data: BarDatum[];
  caption: string;
}) {
  const max = Math.max(1, ...data.map((d) => d.value));

  return (
    <figure className="chart">
      <figcaption className="chart__caption">{caption}</figcaption>
      <ul className="barchart">
        {data.map((d) => (
          <li key={d.label} className="barchart__row">
            <span className="barchart__label" title={d.label}>
              {d.label}
            </span>
            <svg
              className="barchart__track"
              viewBox="0 0 100 8"
              preserveAspectRatio="none"
              role="img"
              aria-label={`${d.label}: ${d.value}`}
            >
              <rect
                className="barchart__bar"
                x="0"
                y="0"
                width={(d.value / max) * 100}
                height="8"
              />
            </svg>
            <span className="barchart__value">{d.value}</span>
          </li>
        ))}
      </ul>
    </figure>
  );
}
